import { GetterTree } from 'vuex';
import { RootState } from '@/store/types';
import { EmailsState } from '@/store/emails/types';

export const getters: GetterTree<EmailsState, RootState> = {
  //
};
